module.exports = __webpack_public_path__ + "static/fonts/ElegantIcons.fdd9e75.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/elegant_font/fonts/ElegantIcons.woff
// module id = TKkb
// module chunks = 25